import { z } from "zod";

export const updateDocumentSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "Name is required")
    .max(255, "Name is too long"),

  description: z
    .string()
    .trim()
    .max(2000, "Description is too long")
    .optional()
    .or(z.literal("")),
});

export type TUpdateDocumentForm = z.infer<typeof updateDocumentSchema>;
